
/**
 *  @description Function that takes in an object with an aspect ratio (ratio) and either 
 * a width or height (w, h) and returns the other dimension.
 * @param {Object} - Object with an aspect ratio (ratio) and either a width or height (w, h)
 * @return {Number}
 */
export function getDimensionFromAspectRatio({ height, width, ratio }) {
  if (!height) {
    return Math.round(width / ratio);
  }
  if (!width) {
    return Math.round(height * ratio);
  }
}

export function getWidthAndHeight({ width, height, defaultWidth, defaultHeight, aspectRatio }) {
  if ( !defaultWidth || !defaultHeight ) {
    throw new Error('defaultWidth and defaultHeight are required');
  }
  if ( !aspectRatio ) {
    throw new Error('aspectRatio is required');
  }

  let svgWidth, svgHeight;
  if (width && height) {
    svgWidth = width;
    svgHeight = height;
  }
  else if (width) {
    svgHeight = getDimensionFromAspectRatio({ width, ratio: aspectRatio });
    svgWidth = width;
  } else if (height) {
    svgWidth = getDimensionFromAspectRatio({ height, ratio: aspectRatio });
    svgHeight = height
  } else {
    svgWidth = defaultWidth;
    svgHeight = defaultHeight;
  }
  return ([svgWidth, svgHeight].map(dimension => `${dimension}`));
}


// WEBPACK FOOTER //
// app/components/Logo/helpers.js